import { Injectable } from '@angular/core';
import { ApiResult, JsonApiClient, JsonServiceClient } from '@servicestack/client';
import {environment, GetGorevSayac_Request, GetGorevSayac_Response, UtilsService} from "@dabnet-kamu/libs/ui";
import { AuthService } from '@dabnet-kamu/libs/auth';
import { GetResim_Request, ImageResponse, ResimSourceType } from '../../../models/genpg.models';

@Injectable({
  providedIn: 'root',
})
export class GenOrtManuelService {

   private client = new JsonServiceClient(environment.ortakService);

    constructor(
      private authService: AuthService,
      private utilsService: UtilsService
    ) {
      const accessToken = this.authService.loggedUser?.access_token;
      const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      };
      this.client.headers.append('Content-Type', headers['Content-Type']);
      this.client.headers.append('Authorization', headers['Authorization']);
    }

  async GetGorevSayac_Request(request?: GetGorevSayac_Request): Promise<any> {

      return await this.client.api(
        new GetGorevSayac_Request({
          sayacTur: request?.sayacTur,
        })
      );
  }

  async GetResim_Request(request?: GetResim_Request): Promise<ApiResult<ImageResponse>> {
    return await this.client.api(new GetResim_Request({
      resimKod: request?.resimKod,
      sourceType: request?.sourceType,
      base64Yn: request?.base64Yn,
    }));
  }
}
